<template>
<div class="sendNoticeVue">
    <!-- HUGE COMMENT -->
        <!-- Please add autocomplete='off' to all input fields or at form level -->

 <!-- Main Body Content area -->
        <div class="o-main-content-area o-main-content-area--padBotoomNone">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <!-- <div class="col-md-6">
                    <h1 class="h1">Add Employer:</h1>
                </div>
                <div class="col-md-6 text-right">
                    <ul class="o-filter-area">
                        <li><a @click="submitNewEmployee()" class="c-common-btn c-common-btn--large c-common-btn--green">  <i class="fa fa-plus" aria-hidden="true"></i>Submit new employer </a></li>
                    </ul>
                </div> -->
                <div class="col-sm-12">
                    <div class="text-center">
                        <ul class="o-filter-area notic-ul-item">
                            <li class="notic-li-item">
                                <span class="req-text">* </span><span>Employee accounts are managed by Call Steward, although as a client, you control the access that Employee is granted.</span>
                            </li>
                            <li class="notic-li-item">
                                <span class="req-text">* </span><span>Before you add an Employee to your own list, please do a search to avoid duplicate entries.</span>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
            <div class="row c-responsive-fixwidth">
                <div class="col-md-12">
                    <h1 class="h1 text-center">Add Employee</h1>
                </div>
            </div>
            <!-- /Heading Section -->
        </div>
        <!-- /Main Body Content area -->
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="col-md-8 col-md-offset-2">
                <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Search Employee:</label>
                                <input autocomplete="off" type="text" v-model="search_query" v-on:keyup="getEmployees()" class="form-control" placeholder="Search Email">
                            </div>
                        </div>
                    </div>
                    <div v-loading="loading" v-if="search_query" class="custom-list-search-background">
                        <div v-for="(employee, inx) in addEmployerlist" class="row custom-list-search" :key="inx">
                            <div class="col-sm-4 o-accordion-subtext o-rowtable-text">
                                <div>{{employee.first_name+' '+employee.last_name}}</div>
                            </div>
                            <div class="col-sm-5">
                                <div>{{employee.email}}</div>
                                
                            </div>
                            <div class="col-sm-3" style="text-align: right;">
                                <a href="javascript: void(0)" @click="addEmployee(employee)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i>Add</a>
                            </div>
                        </div>
                        <div v-if="addEmployerlist.length==0 && apires" class="row">
                            <div class="col-sm-12" style="text-align: center;">
                                <div>Employee Not Found</div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row c-responsive-fixwidth line-break-between-section">
                    <div class="col-md-12">
                        <h1 class="h1 text-center">Check Employee Availability</h1>
                    </div>
                </div>
                <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Enter Email:</label>
                                <input autocomplete="off" class="form-group form-control" type="email" name="email" placeholder="Email" v-model="employerExistEmail">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-center">
                                <ul class="o-filter-area">
                                    <li>
                                        <a href="javascript: void(0)" @click="checkEmail()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-paper-plane" aria-hidden="true"></i> Check</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 line-break-between-section">
                    <div class="text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="submitNewEmployee()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"> <i class="fa fa-plus" aria-hidden="true"></i>Submit new Employee</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="col-md-12">
                    <a @click="submitNewEmployee()" class="c-common-btn c-common-btn--large c-common-btn--green">  <i class="fa fa-plus" aria-hidden="true"></i>Submit new employer </a>
                </div> -->
            </div>

        </div>
</div>

</template>
<script>
    import {bus} from '../../main';
    import {mapGetters, mapActions} from 'vuex';
    import service from '../../services.js';
    let timeout = null;
    export default {
        data() {
            return {
                addEmployerlist:[],
                selectesEmployerId:[],
                loading:false,
                employerExistEmail:'',
                search_query:'',
                apires:false,
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        methods: {
            addEmployee(employee){
                // this.loading=true;
                    service.post('employee/createClientEmployeesAssociation', { 'userId':employee.id },
                    {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        // console.log(res);
                        this.$store.dispatch('selectEmployee', {
                            'id': res.data.result.id,
                            'name': employee.first_name+' '+employee.last_name,
                            'type': res.data.result.employable_type
                        });
                        this.$store.dispatch('setEditEmployeesFrom', 'editEmployeeList');
                        this.$router.push({
                            'path': '/editEmployee/'+btoa(res.data.result.id)
                        });
                    }).catch(err =>{
                        this.$notify({
                            title: this.$t('error'),
                            message: 'Something went wrong please try again later.',
                            type: 'error'
                        });
                    })
            },
            checkEmail(){
                service.get('user/emailExists', {
                    'Authorization': this.userToken,
                    'email':this.employerExistEmail,
                }).
                then((res) => {
                    // console.log("Email Status", res.data.result);the emaill already exists as an employer
                    if(res.data.result==0){
                        this.$notify({
                            title: this.$t('error'),
                            message: 'The Email already exists with other client, Please add employee',
                            type: 'error'
                        });
                    }else{
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Your email address is not registered. Please register.',
                            type: 'success'
                        });
                    }
                   
                }).catch((err) => {
                    console.log(err);
                });
            },
            // addEmployee(){
            //     if(this.selectesEmployerId.length>0){
            //         this.loading=true;
            //         service.post('employer/clientEmployerAssociation', 
            //         {
            //             'employerIds':JSON.stringify(this.selectesEmployerId),
            //         },
            //         {
            //             'Authorization': this.userToken,
            //             'cs3-context-role': this.userRole,
            //             'cs3-context-clientId': this.userClientID
            //         }).
            //         then((res) => {
            //             this.$notify({
            //                 title: this.$t('success'),
            //                 message: 'Employer added Successfully.',
            //                 type: 'success'
            //             });
            //             this.loading=false;
            //             this.$router.go(-1);
            //         }).catch((err) => {
            //             this.loading=false;
            //             this.$notify({
            //                 title: this.$t('error'),
            //                 message: 'Sorry! something went wrong.',
            //                 type: 'error'
            //             });
            //         });
            //     }else{
            //         this.$notify({
            //             title: this.$t('error'),
            //             message: 'Please select employer.',
            //             type: 'error'
            //         });
            //     }
            // },
            submitNewEmployee(){
                this.$router.push({
                    path: "/addEmployee"
                });
            }, 
            
            getEmployees(){
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    if(this.search_query){
                        this.loading=true;
                        this.apires=false;
                        service.get('employee/getNonClientEmployees', {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'search':this.search_query,
                        }).
                        then((res) => {
                            this.addEmployerlist = res.data.result;
                            this.loading=false;
                            this.apires=true;
                        }).catch((err) => {
                            this.loading=false;
                            this.apires=true;                            
                        });
                    }
                }, 1000);
            }
        },
        created() {
            
        }
    }

</script>
<style scoped>
.custom-list-search{
    margin: 5px;
    padding: 5px;
    border-bottom: 1px solid #afacac;
    word-break: break-all;
}

.custom-list-search-background{
    background-color: #f4f7f8;
    padding: 5px;
    border-radius: 6px;
    max-height: 350px;
    overflow-y: scroll;
    overflow-x: hidden;
}
.el-select-dropdown__item{
    padding-right: 40px;
}
.el-input__inner {
    /* display: none; */
    height: auto !important;
}
.line-break-between-section{
    margin-top: 50px;
}
.notic-ul-item{
    border-radius: 6px;
    background-color: #e4d8d8;
    padding: 10px;
}
.notic-li-item{
    padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/employees/clientEmployeeAssociation.vue